import Icon from '../components/Icon.vue'

Icon.register({
  'fast-forward': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-151.9l-171.5 156.5c-20.6 17.2-52.5 2.8-52.5-24.6v-131.9l-171.5 156.5c-20.6 17.2-52.5 2.8-52.5-24.6v-320c0-27.4 31.9-41.7 52.5-24.6l171.5 155.4v-130.8c0-27.4 31.9-41.7 52.5-24.6l171.5 155.4v-150.8c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z'
      }
    ]
  }
})
